export default {
  createValueAddedActivity: '/valueAddedActivity/createValueAddedActivity',
  getValueAddedActivityAll: '/valueAddedActivity/getValueAddedActivityAll',
  getValueAddedActivity: '/valueAddedActivity/getValueAddedActivity',
  updateValueAddedActivity: '/valueAddedActivity/updateValueAddedActivity',
  deleteValueAddedActivity: '/valueAddedActivity/deleteValueAddedActivity'

}
